import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { initMercadoPago } from '@mercadopago/sdk-react';
import { CustomToast } from 'components'

// Remaining code

initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY, { locale: 'es-UY' });

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <>
      <App />
      <Toaster
        position="top-right"
        containerStyle={{ zIndex: 20000 }}
        toastOptions={{
          duration: 6500,
          style: {
            borderRadius: '8px',
            fontFamily: 'Inter, sans-serif',
            padding: '12px',
            maxWidth: '350px',
            wordBreak: 'break-word',
            color: 'white',
          },
        }}
      >
        {(t) => <CustomToast {...t} />}
      </Toaster>
    </>
  </React.StrictMode>
);
